module.exports = __webpack_public_path__ + "img/time1.71c2e0b6.svg";